export enum F1040Error {
  unsupportedTaxYear = 'Tax year not supported',
  incompletePrimaryTaxpayer = 'Taxpayer information not completed',
  filingStatusUndefined = 'Select a filing status',
  filingStatusRequirementsNotMet = 'Filing status does not match dependents or spouse requirements',
  unknown = 'Unknown error'
}
